import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { comics } from '@/mocks/comics';

const heroSlides = [
  {
    id: 6,
    title: '朝鲜风云录',
    description: '朝鲜王朝中期，权臣当道。少年李萱获得武学秘籍，踏上匡扶正义之路。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20epic%20historical%20scene%20with%20Joseon%20dynasty%20warrior%20in%20dramatic%20action%20pose%2C%20ancient%20Korean%20palace%20silhouette%20background%2C%20warm%20sunset%20lighting%2C%20cinematic%20composition%2C%20epic%20atmosphere%2C%20wind%20effects&width=1400&height=700&seq=hero-slide-01&orientation=landscape',
  },
  {
    id: 2,
    title: '星之契约者',
    description: '少年星痕契约灭世之星，踏上寻找真相的冒险之旅。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20fantasy%20scene%20with%20magical%20stars%20falling%20from%20sky%2C%20hero%20standing%20on%20cliff%20edge%2C%20cosmic%20nebula%20background%2C%20dramatic%20lighting%2C%20epic%20fantasy%20atmosphere%2C%20cinematic%20wide%20shot&width=1400&height=700&seq=hero-slide-02&orientation=landscape',
  },
  {
    id: 13,
    title: '财阀家的小女儿',
    description: '韩国最大财阀家族小女儿，在男性主导的商业世界杀出血路。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20modern%20city%20skyline%20scene%20with%20elegant%20woman%20in%20business%20suit%2C%20Seoul%20night%20cityscape%20background%2C%20sophisticated%20cinematic%20lighting%2C%20dramatic%20atmosphere%2C%20luxury%20mood&width=1400&height=700&seq=hero-slide-03&orientation=landscape',
  },
];

export default function HeroSection() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % heroSlides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const slide = heroSlides[current];

  return (
    <section className="relative w-full h-[420px] md:h-[560px] overflow-hidden">
      {heroSlides.map((s, index) => (
        <div
          key={s.id}
          className={`absolute inset-0 transition-opacity duration-700 ${index === current ? 'opacity-100' : 'opacity-0'}`}
        >
          <img
            src={s.cover}
            alt={`${s.title} 韩国漫画推荐`}
            className="w-full h-full object-cover object-top"
          />
        </div>
      ))}
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/15 to-black/50"></div>

      <div className="absolute bottom-0 left-0 right-0 p-6 md:p-10">
        <div className="max-w-7xl mx-auto w-full flex flex-col md:flex-row items-end md:items-center justify-between gap-6">
          <div className="max-w-xl">
            <span className="inline-block text-xs px-3 py-1 rounded-full bg-primary-500/90 text-white mb-3">
              精选推荐
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-black text-white mb-2">
              {slide.title}
            </h2>
            <p className="text-sm md:text-base text-white/80 line-clamp-2">
              {slide.description}
            </p>
            <Link
              to={`/article/${slide.id}`}
              className="inline-flex items-center gap-2 mt-4 px-5 py-2.5 rounded-full bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              立即阅读
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="flex items-center gap-1.5">
            {heroSlides.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrent(index)}
                className={`w-2.5 h-2.5 rounded-full transition-all duration-300 cursor-pointer ${
                  index === current
                    ? 'bg-primary-500 w-8'
                    : 'bg-white/50 hover:bg-white/80'
                }`}
                aria-label={`切换到第${index + 1}张`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}